import React from 'react';

interface DataSourceIndicatorProps {
  source: 'api' | 'mock';
  className?: string;
}

/**
 * Visual indicator showing whether data is from live API or mock fallback
 */
export const DataSourceIndicator: React.FC<DataSourceIndicatorProps> = ({ source, className = '' }) => {
  const isLive = source === 'api';
  
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium ${className}`}>
      <div className={`relative flex h-2 w-2`}>
        <span 
          className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
            isLive ? 'bg-green-400' : 'bg-yellow-400'
          }`}
        />
        <span 
          className={`relative inline-flex rounded-full h-2 w-2 ${
            isLive ? 'bg-green-500' : 'bg-yellow-500'
          }`}
        />
      </div>
      <span className={isLive ? 'text-green-700 dark:text-green-400' : 'text-yellow-700 dark:text-yellow-400'}>
        {isLive ? 'Live Data (Backend API)' : 'Mock Data (Fallback)'}
      </span>
    </div>
  );
};
